import { render, staticRenderFns } from "./ChatMessageImage.vue?vue&type=template&id=6fd2ad22&scoped=true&"
import script from "./ChatMessageImage.vue?vue&type=script&lang=js&"
export * from "./ChatMessageImage.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageImage.vue?vue&type=style&index=0&id=6fd2ad22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2ad22",
  null
  
)

export default component.exports